module.exports = __webpack_public_path__ + "static/media/BrianSu@2x.5a3eac44.png";